import { Component, ElementRef, ViewChild } from "@angular/core";
import { NightModeService, ConfettiService, ThemesService } from "@core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ThemeVar } from "@model";
import { AppErrorService } from "@core";

declare let require: any;
const confetti = require("canvas-confetti");

@Component({
  selector: "app-confetti-overlay",
  standalone: true,
  imports: [],
  templateUrl: "./confetti-overlay.component.html",
  styleUrl: "./confetti-overlay.component.scss",
})
export class ConfettiOverlayComponent {
  @ViewChild("canvasElement") canvas!: ElementRef;

  private _isNightMode = false;

  constructor(
    private _nightModeService: NightModeService,
    private _confettiService: ConfettiService,
    private _themeService: ThemesService,
    private _appErrorService: AppErrorService,
  ) {
    this._confettiService.showConfetti$.pipe(takeUntilDestroyed()).subscribe((count: number) => {
      this._showConfetti(count);
    });

    this._nightModeService.isNightMode$
      .pipe(takeUntilDestroyed())
      .subscribe((v) => (this._isNightMode = v));
  }

  private _showConfetti(count: number): void {
    if (!this.canvas || this._appErrorService.getIsError()) {
      return;
    }
    const canvasElement = this.canvas.nativeElement;
    canvasElement.confetti =
      canvasElement.confetti || confetti.create(canvasElement, { resize: true });

    const show = (withColor: boolean) => {
      const config = this._getConfettiConfig(withColor);
      return canvasElement.confetti(config);
    };

    setTimeout(() => show(true), 100);

    if (count >= 2) {
      setTimeout(() => show(true), 800);
    }

    if (count >= 3) {
      setTimeout(() => show(true), 1200);
    }
  }

  private _getConfettiConfig(withColor: boolean): Record<string, unknown> {
    const colorVar1 = this._isNightMode ? ThemeVar.THEME_12 : ThemeVar.THEME_4;
    const colorVar2 = this._isNightMode ? ThemeVar.THEME_16 : ThemeVar.THEME_8;
    const colorVar3 = this._isNightMode ? ThemeVar.THEME_20 : ThemeVar.THEME_12;
    const color1 = this._themeService.getThemeColor(colorVar1);
    const color2 = this._themeService.getThemeColor(colorVar2);
    const color3 = this._themeService.getThemeColor(colorVar3);

    const defaultConfig = {
      spread: 70,
      origin: { y: 1.2 },
      decay: 0.94,
      colors: withColor ? [color1, color2, color3] : null,
    };

    return this._isNightMode
      ? {
          particleCount: 500,
          ...defaultConfig,
        }
      : {
          particleCount: 150,
          shapes: ["circle"],
          scalar: 2,
          gravity: 0.5,
          ...defaultConfig,
        };
  }
}
